import { ComponentProps, useState } from 'react';
import { Box } from 'native-base';

import StoreHoursTable from './components/store-hours-table';

export const StoreHours = () => {
  const [sections] = useState<ComponentProps<typeof StoreHoursTable>['sections']>([
    {
      index: 0,
      title: 'store_operating_hours',
      data: [
        { title: 'closed_non_op', dataFields: ['isClosed'] },
        { title: 'dining_room', dataFields: ['hasDiningRoom'] },
        { title: 'dining_room_hours', dataFields: ['diningRoomOpen', 'diningRoomClose'] },
        { title: 'drive_thru_puw', dataFields: ['hasPickupWindow'] },
        { title: 'drive_thru_hours', dataFields: ['driveThruOpen', 'driveThruClose'] },
      ],
    },
    {
      index: 1,
      title: 'food_service_hours',
      data: [
        { title: 'open_twentyfour_hours', dataFields: ['open24Hrs'] },
        { title: 'serves_breakfast', dataFields: ['iServesBreakfast'] },
        { title: 'breakfast_hours', dataFields: ['breakfastStart', 'breakfastEnd'] },
        { title: 'lunch_hours', dataFields: ['lunchStart', 'lunchEnd'] },
        { title: 'dinner_hours', dataFields: ['dinnerStart', 'dinnerEnd'] },
        { title: 'service_hours', dataFields: ['storeOpen', 'storeClose'] },
      ],
    },
  ]);

  return (
    <Box flex={1} borderTopWidth={1} borderColor="gray.200">
      <StoreHoursTable sections={sections} />
    </Box>
  );
};
